import api from '@/api';

import { API_BASE_URL } from '..';
import {
  MaterialReturnDetail,
  MaterialReturnListRequest,
  MaterialReturnRequest,
  MaterialReturnResponse,
  ReturnMaterialResponseList,
} from './MaterialReturn.types';
import { PageResultStock } from '@/core/request/PageResultStock';

const CONTROLLER_URL = `${API_BASE_URL}/materials/returns`;

export async function materialReturnList(params?: MaterialReturnListRequest) {
  const result = (await api.get(`${CONTROLLER_URL}/to-be`, params)) as unknown;

  return result as PageResultStock<ReturnMaterialResponseList>;
}

export async function returnMaterial(
  obj: MaterialReturnRequest,
): Promise<MaterialReturnResponse> {
  const result = (await api.post(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result as MaterialReturnResponse;
}

export async function returnMaterialDetail(id?: string) {
  const result = (await api.get(`${CONTROLLER_URL}/${id}`, {})) as unknown;

  return result as MaterialReturnDetail;
}
